import ChildNodeIds from './ChildNodeIds';
import NodeIds from './NodeIds';
import InputMetadata from './InputMetadata';
import { InputMetadataEntry } from '../types';

type ChildInputMetadataType = {
    [ChildNodeId: string]: {
        [InputId: string]: InputMetadataEntry;
    };
};

const ChildInputMetadata: ChildInputMetadataType = {
    [ChildNodeIds.GeneralInformation.ContractRenewal]: InputMetadata[NodeIds.GeneralInformation]
};

export default ChildInputMetadata;
